// Typelizer digest a33835f548204b28765efa512fcbb24f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/counterparties/:counterparty_id/merge */
  create: (
    params: { counterpartyId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/counterparties/:counterparty_id/merge', params, options),
    method: 'post',
  }),
}
